import styled from 'styled-components';

export const DashboardContainer = styled.div.attrs({
  className: 'w-full bg-white mb-8',
})`
  border: 0.5px solid rgba(98, 120, 140, 0.2);
  border-radius: 15px;

  .header {
    background: rgba(98, 120, 140, 0.05);
    padding: 20px 40px;

    .title {
      font-size: 20px;
      line-height: 25.64px;
      font-weight: 600;
    }
    .name {
      margin-top: 9px;
      font-size: 16px;
      line-height: 20.51px;
    }
  }

  .body {
    padding: 14px 40px;
    padding-top: 32px;

    .filter-bar {
      display: flex;
      align-items: center;
      margin-bottom: 40px;

      button {
        border-radius: 15px;
        font-size: 16px;
        padding: 16px;
      }

      .search-bar {
        display: flex;
        border: 0.5px solid rgba(98, 120, 140, 0.4);
        padding: 10px 13px;
        border-radius: 15px;
        margin-right: 22px;
        width: 271px;

        svg {
          margin-right: 10px;
        }

        input {
          flex-grow: 1;
        }
      }

      .filter-button {
        border: 0.5px solid rgba(98, 120, 140, 0.4);
        border-radius: 100%;
        width: 45px;
        height: 45px;
        display: flex;
        align-items: center;
        justify-content: center;

        &.selected {
          background: rgba(24, 28, 52);

          svg {
            fill: white;
          }
          &:hover {
            background: rgba(24, 28, 52);
            cursor: pointer;
          }
        }

        &:hover {
          background: rgba(98, 120, 140, 0.05);
          cursor: pointer;
        }
      }
    }

    .table-container {
      overflow: auto;

      .table-header {
        font-weight: 600;
        font-size: 20px;
        margin-bottom: 20px;
        display: grid;
        grid-template-columns: 200px 300px 150px 200px 150px;
        column-gap: 20px;
      }

      .table-body {
        display: grid;
        gap: 20px;

        .row {
          display: grid;
          grid-template-columns: 200px 300px 150px 200px 150px;
          column-gap: 20px;
        }
      }

      .show-course-btn {
        width: fit-content;
        padding: 2px 8px;

        &:hover {
          background: rgba(98, 120, 140, 0.05);
          cursor: pointer;
          border-radius: 100px;
        }
      }
    }
  }
`;

export const MenuContainer = styled.div.attrs({
  className: 'bg-white rounded absolute',
})`
  z-index: 1;
  right: 0;
  top: 60px;
  box-shadow: 0px 14px 14px 0px rgba(98, 120, 140, 0.1);
  padding: 25px;
  border-radius: 20px;
  border: 0.5px solid rgba(98, 120, 140, 0.1);
  width: 272px;

  button {
    border-radius: 15px;
    font-size: 16px;
    padding: 8px 30px;
    height: 35px;
  }
`;
